module.exports = __webpack_public_path__ + "img/arrow-down.c6221654.svg";